module.exports = __webpack_public_path__ + "img/cs-iosC-2.e05c7f99.jpg";